<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="list"></ng-container>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectworkingorder_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <ng-container *ngTemplateOutlet="list"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>

    <p *ngIf="error" role="alert">{{ error }}</p>
</tt-page>

<ng-template #list>
    <ng-container>
        <tt-card>
            <tt-input ttLabel="search" [(ttModel)]="filterText" ttShowClearButton></tt-input>
        </tt-card>

        <tt-list [ttData]="filteredItems" ttBackStyle [ttGoto]="false" (ttClick)="select($event.item)"></tt-list>
    </ng-container>
</ng-template>
